import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'activityClient', method: 'GET', body: null, token: token })
}
